<template>
    <div>
        <div class="shopping-bag-box" v-if="showCartBag" @click="toggleCart">
            <div class="shop-bag-icon">
                <i class="fa fa-shopping-bag"></i>
                <span class="shop-cart-qty">
                    {{ total_quantity }} Items
                </span>
            </div>
            <div class="shop-bag-foot">
                &#2547; {{ Number(total_price).toFixed(2) }}
            </div>
        </div>
        <app-cart-view v-if="showCartBox" />
    </div>
</template>

<script>
    import {mapGetters, mapState} from 'vuex'
    export default {
        name: "Cart",
        props: {
            isLoggedIn: {
                type: Boolean | Number,
                default: false
            }
        },
        computed: {
            ...mapState({
                showCartBox: state => state.cart.showCartBox,
                showCartBag: state => state.cart.showCartBag,
            }),
            ...mapGetters({
                total_price: 'total_price',
                total_quantity: 'totalQuantity',
            }),
        },
        methods: {
            toggleCart() {
                this.$store.dispatch('setShowCartBox', true);
                this.$store.dispatch('setShowCartBag', false);
            }
        },
        mounted() {
            this.$store.dispatch('getCarts');
            this.$store.commit('SET_IS_LOGGED_IN', this.isLoggedIn)
        },
    }
</script>

<style scoped>

</style>